<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" @refresh="onRefresh">
        <template slot="table-filter">
            <b-form>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nome farmaco:</label>
                        <b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.descrizione" :placeholder="this.$i18n.t('therapy.lblDrug')"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">ATC:</label>
                        <b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.atcGmp" placeholder="ATC"></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info" @click="onSubmit">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <banca-farmaci-list-component ref="cmpBancaFarmaciList" @afterLoadData="onAfterLoadData"></banca-farmaci-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
//import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import BancaFarmaciListComponent from "../components/BancaFarmaciListComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, BancaFarmaciListComponent },
    data() {
        return {
            showModalLoading: false,
            filtroFarmaci: { descrizione: null, atcGmp: null },
            pathResourceFarmaci: "/farmaci",
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroFarmaci"]) {
            me.filtroFarmaci = JSON.parse(sessionStorage["filtroFarmaci"]);
            if (me.filtroFarmaci.descrizione != null || me.filtroFarmaci.atcGmp != null) {
                me.loadData();
            }
        }
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.cmpBancaFarmaciList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onSubmit() {
            let me = this;
            me.showModalLoading = true;
            window.sessionStorage.setItem("filtroFarmaci", JSON.stringify(me.filtroFarmaci));
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroFarmaci = { descrizione: null, atcGmp: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroFarmaci"] = JSON.stringify(me.filtroFarmaci);
            me.$refs.cmpBancaFarmaciList.resetList();
        },
    },
};
</script>
